'use client';

import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  isTag?: boolean;
}

interface PageBreadcrumbProps {
  items: BreadcrumbItem[];
  locale?: string;
  center?: boolean;
  className?: string;
}

export const PageBreadcrumb: React.FC<PageBreadcrumbProps> = ({
  items,
  locale = 'en',
  center = false,
  className,
}) => {
  const homeText = locale === 'fr' ? 'Accueil' : 'Home';

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className={cn(
        'flex items-center flex-wrap gap-2 text-xs sm:text-sm font-medium text-[#50456c] dark:text-neutral-400 mb-5 sm:mb-6 tracking-wide',
        center && 'justify-center text-center',
        className
      )}
    >
      <Link
        href={`/${locale}`}
        className="hover:text-[#c02029] transition-colors"
      >
        {homeText}
      </Link>

      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${index}`}>
            <span className="text-[#c02029] font-light select-none">—</span>
            {item.href && !isLast ? (
              <Link
                href={item.href.startsWith('/') ? `/${locale}${item.href}` : item.href}
                className="hover:text-[#c02029] transition-colors"
              >
                {item.label}
              </Link>
            ) : item.isTag ? (
              <span className="text-[#c02029] font-medium">{item.label}</span>
            ) : (
              <span className="text-[#2e1452] dark:text-neutral-200 font-semibold">
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </motion.div>
  );
};

export default PageBreadcrumb;
